<script>
import options from './FundraisingAsideVue.options'
export default options
</script>

<template>

  <aside class="kb-aside kb-aside--fundraising-aside kb-fundraising-aside-vue">

    <div class="kb-fundraising-aside__content-container">

      <template v-if="detailItems?.length > 0 || creatorProfile">

        <h2 class="kb-fundraising-aside__title">
          {{getLabel("title")}}
        </h2>

        <div class="kb-fundraising-aside__wrapper">

          <template v-if="creatorProfile?.firstName && creatorProfile?.lastName">

            <ul class="kb-fundraising-aside__item">
                <li class="kb-fundraising-aside__item-icon kb-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"> <path fill="#3C3C3C" fill-rule="evenodd" d="M5 4h1v2h6V4h1v2h6V4h1v2h6V4h1v2h2a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2V4Zm21 3v2h1V7h2v4H3V7h2v2h1V7h6v2h1V7h6v2h1V7h6Zm3 5v14H3V12h26Z" clip-rule="evenodd"/> </svg>
                </li>
                <li class="kb-fundraising-aside__item-content">
                  <h3>{{getLabel("creatorProfileLabel")}}</h3>
                  <p class="kb-fundraising-aside__item-content-text">
                    {{ creatorProfile.firstName + ' ' + creatorProfile.lastName}}
                  </p>
                </li>
              </ul>
          
          </template>

          <template v-if="addressDetails?.postalCode">

            <ul class="kb-fundraising-aside__item">
                <li class="kb-fundraising-aside__item-icon kb-icon">
                    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 12C7.5 7.30558 11.3056 3.5 16 3.5C20.6944 3.5 24.5 7.30558 24.5 12C24.5 15.8847 22.2776 20.2019 20.0162 23.5739L18.298 22.2985L17.702 23.1015L20.2552 24.9967L20.549 24.5695C22.9198 21.1209 25.5 16.3792 25.5 12C25.5 6.75329 21.2467 2.5 16 2.5C10.7533 2.5 6.5 6.75329 6.5 12C6.5 16.1579 8.82542 20.6395 11.084 24.0273C12.2211 25.733 13.3573 27.1848 14.2092 28.2101C14.6353 28.7231 14.9908 29.13 15.2405 29.4093C15.3653 29.549 15.4637 29.6569 15.5312 29.7302C15.565 29.7668 15.5911 29.7949 15.6089 29.8139L15.6294 29.8357L15.6348 29.8415L15.6368 29.8436L16 30.227L16.3661 29.8406L16.3741 29.8321L16.404 29.8001C16.4301 29.772 16.4684 29.7308 16.5177 29.6769C16.6164 29.5692 16.7595 29.4109 16.939 29.207C17.2981 28.7993 17.8033 28.2087 18.3905 27.4744L17.6095 26.8498C17.0335 27.5701 16.5387 28.1485 16.1886 28.5461C16.12 28.624 16.057 28.6949 16 28.7585L15.9861 28.743C15.7436 28.4716 15.396 28.0738 14.9783 27.5711C14.1427 26.5652 13.0289 25.142 11.916 23.4727C9.67458 20.1105 7.5 15.8421 7.5 12ZM16 29.5L15.6368 29.8436C15.6368 29.8436 15.637 29.8439 16 29.5Z" fill="#3C3C3C"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 5.5C12.4101 5.5 9.5 8.41015 9.5 12C9.5 15.5899 12.4101 18.5 16 18.5C19.5899 18.5 22.5 15.5899 22.5 12C22.5 8.41015 19.5899 5.5 16 5.5ZM10.5 12C10.5 8.96243 12.9624 6.5 16 6.5C19.0376 6.5 21.5 8.96243 21.5 12C21.5 15.0376 19.0376 17.5 16 17.5C12.9624 17.5 10.5 15.0376 10.5 12Z" fill="#3C3C3C"/>
                    </svg>
                </li>
                <li class="kb-fundraising-aside__item-content">
                  <p class="kb-fundraising-aside__item-content-text">
                    {{ [addressDetails.postalCode, addressDetails.city].filter(Boolean).join(' ') }}
                  </p>
                </li>
              </ul>

          </template>

          <template v-for="item, index in detailItems" :key="index">

              <ul class="kb-fundraising-aside__item">
                <li class="kb-fundraising-aside__item-icon kb-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"> <path fill="#3C3C3C" fill-rule="evenodd" d="M5 4h1v2h6V4h1v2h6V4h1v2h6V4h1v2h2a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2V4Zm21 3v2h1V7h2v4H3V7h2v2h1V7h6v2h1V7h6v2h1V7h6Zm3 5v14H3V12h26Z" clip-rule="evenodd"/> </svg>
                </li>
                <li class="kb-fundraising-aside__item-content">
                  <h3>{{item.title}}</h3>
                  <p class="kb-fundraising-aside__item-content-text">
                    {{ item.description }}
                  </p>
                </li>
              </ul>

          </template>

        </div>
      </template>

      <template v-if="!isAuthenticated || ownsPersonalFundraising">
        <div class="kb-fundraising-aside__button-wrapper">
          <a :href="loginLogoutButton.link" class="kb-button">{{isAuthenticated ? getLabel("logoutButtonText") : getLabel("loginButtonText")}}</a>
        </div>
      </template>

    </div>

    <template v-if="ownsPersonalFundraising">
      <div class="kb-fundraising-aside__link-wrapper">
        <a :href="editFundraising.link"  class="kb-fundraising-aside__link-wrapper__link">
          <span class="kb-ui-icon kb-ui-icon--ui-chart"></span>{{getLabel("editFundraisingText")}}</a>
      </div>
    </template>

    <div class="kb-fundraising-aside__link-wrapper" v-if="useQrCode">
      <button @click="openPageOverlay" class="kb-fundraising-aside__link-wrapper__link">
        <div class="kb-fundraising-aside__QR-img">
          <img :src="`data:image/png;base64, ${qrImgUrlBase}`" :alt='getLabel("qrCodeImgAlt")' />
        </div>
       {{ getLabel("qrCodeText") }}
      </button>
    </div>
  </aside>
</template>
